import type { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';

export const loadProfileChecklistRoutes: Route = {
  path: 'load-profile-checklist',
  loadComponent: () =>
    import('./load-profile-checklist.component').then(
      (mod) => mod.LoadProfileChecklistComponent,
    ),
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('@backoffice-frontend/setting-lib').then(
          (mod) => mod.LoadProfileChecklistFormComponent,
        ),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};
